module.exports = __webpack_public_path__ + "static/media/Profile.f529e9ac.svg";